import { computed, observable, action, when } from 'mobx'
import * as routes from 'routes/config'
import { objectValues } from 'shared/utils/src/object';

const DEFAULT_ROUTE = '/'

export default class RouterService {

  @observable match = {}
  @observable history = {}
  @observable location = {}

  @computed
  get routes() {
    return objectValues(routes)
  }

  transitionTo(route = DEFAULT_ROUTE, replace = false) {
    // eslint-disable-next-line
    const url = route && route.path || route

    when(
      () => this.history && this.history.push && this.history.replace,
      () => {
        if (replace)
          this.history.replace(url)
        else
          this.history.push(url)
      }
    )
  }

  @action.bound
  bind({ match = {}, history = {}, location = {} }) {
    this.match = match
    this.history = history
    this.location = location
  }

}



// WEBPACK FOOTER //
// ./src/services/router.js